const getTabList = (pageController, history) => {
  return [
    {
      label: 'Home',
      isActive: pageController.mainPage,
      onClick: () => history.push(`/`),
    },

    {
      label: 'Courses',
      isActive: pageController.courses,
      onClick: () => history.push(`/courses`),
    },
    {
      label: 'Learning paths',
      isActive: pageController.collections,
      onClick: () => history.push(`/collections`),
    },
  ]
}

export default getTabList
